import React, { useState, useEffect } from "react";

import { IoMdBookmarks } from "@react-icons/all-files/io/IoMdBookmarks";
import { AiOutlinePlus } from "@react-icons/all-files/ai/AiOutlinePlus";

function CreateNewChaps({
  slicingEmptyObjects,
  setNotChapter,
  indexOfChap,
  setAddChap,
  addChap,
  novelData,
  novelChaps,
  setNovelChaps,
}) {
  const [description, setDescription] = useState(null);
  const [error, setErrors] = useState("");
  const [success, setSuccess] = useState(false);
  const [sent, setSent] = useState(false);

  let titleRule = novelChaps[indexOfChap]?.chapterName
    ?.trim()
    ?.split(/ +/)
    ?.join(" ");
  let desRule = novelChaps[indexOfChap]?.chapterBody
    ?.trim()
    ?.split(/ +/)
    ?.join(" ");

  function clear() {
    // if im inside add chapters do this
    if (slicingEmptyObjects) {
      novelChaps.splice(indexOfChap, 1);
      setAddChap(false);
    } else {
      // if not do this
      if (titleRule.length < 5) {
        setErrors("title must be at least 5 Charaters!");
      } else if (desRule.length < 5000) {
        setErrors("description must be at least 5000 Charaters!");
      } else {
        // chapter added Successfully
        setAddChap(false);
        setNotChapter(
          1,
          setTimeout(() => {
            setNotChapter(5);
          }, 2000)
        );
      }
    }
    // }
  }

  function handleSubmit(e) {
    e.preventDefault();
    setSent(true);

    if (titleRule.length < 5) {
      setSuccess(false);
      setSent(false);
      setErrors("title must be at least 5 Characters!");
    } else if (desRule.length < 5000) {
      setSuccess(false);
      setSent(false);
      setErrors("description must be at least 5000 Characters!");
    } else {
      // chapter added Successfully
      setNotChapter(1);
      setTimeout(() => {
        setNotChapter(5);
      }, 2000);
      setNovelChaps(novelChaps);
      setAddChap(false);
      setErrors("");
      setSent(false);
      setSuccess(true);
      setTimeout(() => {
        setSuccess(false);
      }, 1000);
    }
  }
  const handleChange = (e, idx) => {
    var clone = [...novelChaps];
    let obj = clone[idx];
    obj.chapterName = e.target.value;
    clone[idx] = obj;
    setNovelChaps([...clone]);
  };
  const handleChangeN2 = (e, idx) => {
    var clone = [...novelChaps];
    let obj = clone[idx];
    obj.chapterBody = e.target.value;
    clone[idx] = obj;
    setNovelChaps([...clone]);
  };
  const handleChangeN3 = () => {
    var filtered = novelChaps[indexOfChap]?.chapterBody
      .split(" ")
      .filter((item) => item);
    // reset description length
    setDescription(filtered);
  };
  useEffect(() => {
    handleChangeN3();
  }, [indexOfChap]);
  return (
    <div>
      <div
        onClick={() => {
          clear();
        }}
        className={
          addChap
            ? "absolute z-[1000] purple-full-width  backdrop-blur-[50px] bg-secondary/20 top-0 left-0 h-full w-full opacity-100  duration-500 ease-in-out"
            : "absolute z-[1000] purple-full-width  backdrop-blur-[50px] bg-secondary/20 top-0 left-0 h-full w-full opacity-0 pointer-events-none duration-500 ease-in-out"
        }
      ></div>
      <div
        className={
          addChap
            ? "-translate-y-[0%] opacity-100 w-full md:w-full lg:w-full xl:w-[80%]  2xl:w-[70%] h-full md:h-[90%]  m-auto duration-500 ease-in-out fixed inset-0 z-[10000] "
            : "translate-y-[200%] opacity-0 w-full md:w-full lg:w-full xl:w-[80%]  2xl:w-[70%] h-full md:h-[90%]  m-auto duration-500 ease-in-out fixed inset-0 z-[10000] "
        }
      >
        <div className="w-full md:w-full bg-tertiary lg:w-full xl:w-full  2xl:w-full h-full md:h-full">
          <div className="py-[100px] px-[15px] lg:px-[100px]  relative md:static overflow-y-scroll z-[1000] w-full md:w-full lg:w-full xl:w-full 2xl:w-full h-full md:h-full bg-tertiary duration-500 ease-in-out">
            <form
              onSubmit={handleSubmit}
              className="w-full h-full flex flex-col gap-y-6"
            >
              <div className="bg-primarys w-full text-secondary/50">
                <div className="grid grid-cols-1 md:grid-cols-3 w-full h-fit text-center  border-b-[1px] border-secondary/20">
                  <div className="px-4 capitalize flex justify-center items-center h-full py-6  border-b-[1px] md:border-b-0  border-r-0 md:border-r-[1px] border-secondary/20   ">
                    <IoMdBookmarks className="scale-125" />
                    <span className="text-[14px] sm:text-[16px] flex-1 line-clamp-1 pl-4">
                      {novelData?.title}
                    </span>
                  </div>
                  <div className="text-[14px] sm:text-[16px] capitalize flex justify-center items-center h-full py-6  border-b-[1px] md:border-b-0  border-r-0 md:border-r-[1px] border-secondary/20  ">
                    chapter {indexOfChap + 1}
                  </div>
                  <div className="text-[14px] sm:text-[16px] capitalize flex justify-center items-center py-6 h-full ">
                    {description?.length || 0}{" "}
                    {description?.length >= 2 ? "words" : "word"}
                  </div>
                </div>
                <div className="w-full flex flex-col gap-y-6 py-16 px-[15px] md:px-20">
                  <div className="h-[15%]">
                    <input
                      type="text"
                      placeholder="Title"
                      maxLength={40}
                      value={novelChaps[indexOfChap]?.chapterName || ""}
                      onChange={(e) => {
                        handleChange(e, indexOfChap);
                      }}
                      className="text-secondary text-[14px] sm:text-[16px] capitalize pr-2 bg-primarys placeholder:uppercase placeholder:font-SoraR placeholder:text-secondary/50 outline-none w-full h-[60px] border-b-[1px] border-secondary/20"
                    />
                  </div>
                  <div className="h-[400px] relative">
                    <textarea
                      value={novelChaps[indexOfChap]?.chapterBody}
                      onChange={(e) => {
                        handleChangeN2(e, indexOfChap);
                        handleChangeN3();
                      }}
                      className="text-secondary text-[14px] sm:text-[16px] capitalize pr-2 bg-primarys placeholder:uppercase placeholder:font-SoraR placeholder:text-secondary/50 resize-none outline-none w-full h-full"
                      maxLength={20000}
                      placeholder="Description"
                    ></textarea>
                    <div
                      className={
                        novelChaps[indexOfChap]?.chapterBody
                          ?.trim()
                          ?.split(/ +/)
                          ?.join(" ")?.length > 5000
                          ? "text-primary text-[14px] sm:text-[16px] absolute bottom-0 right-0 py-4 md:py-6 px-4 md:px-8"
                          : "text-secondary text-[14px] sm:text-[16px] absolute bottom-0 right-0 py-4 md:py-6 px-4 md:px-8"
                      }
                    >
                      {
                        novelChaps[indexOfChap]?.chapterBody
                          ?.trim()
                          ?.split(/ +/)
                          ?.join(" ")?.length
                      }
                      /20000
                    </div>
                  </div>
                </div>
              </div>
              <div className="pb-[100px]">
                <button className="z-10 hover:bg-primary/90 duration-500 ease-in-out Purple-btn-effect bg-primary w-full font-SoraS text-tertiary h-[52px] relative">
                  {sent ? <Loading /> : "Publish Chapter"}
                </button>
                {/* errors */}
                <div
                  className={
                    success
                      ? "opacity-100 text-[14px] sm:text-[16px] duration-500 ease-in-out translate-y-0  bg-green-600   capitalize w-full h-[52px] flex items-center px-4 md:px-8 text-tertiary md:mt-6 mt-8"
                      : "opacity-0 h-0 text-[14px] sm:text-[16px] -translate-y-10 duration-500 ease-in-out bg-green-600   capitalize w-full flex items-center px-4 md:px-8 text-tertiary mt-0 "
                  }
                >
                  <h5>Your chapter has been created successfully!</h5>
                </div>
                <div
                  className={
                    error
                      ? "bg-error text-[14px] sm:text-[16px] capitalize opacity-100 duration-500 ease-in-out translate-y-0  w-full h-[52px] flex items-center px-4 md:px-8 text-tertiary md:mt-6 mt-8"
                      : "bg-error text-[14px] sm:text-[16px] opacity-0 -translate-y-10 duration-500 ease-in-out capitalize  w-full h-0 flex items-center px-4 md:px-8 text-tertiary  mt-0"
                  }
                >
                  <h5>{error}</h5>
                </div>
              </div>
            </form>
            {/* remove button */}
            <div
              onClick={() => {
                clear();
              }}
              className=" cursor-pointer absolute bg-error hover:bg-error/90 duration-500 ease-out w-[50px] md:w-[70px] h-[50px] md:h-[70px] top-0 right-0 translate-y-[40%] -translate-x-[15px] md:-translate-y-1/2 md:-translate-x-[40%] flex justify-center items-center"
            >
              <AiOutlinePlus className="flex justify-center items-center text-tertiary scale-[1.5] md:scale-[2] rotate-45" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CreateNewChaps;
function Loading() {
  <div className="flex justify-center items-center scale-75">
    <div role="status">
      <svg
        aria-hidden="true"
        className="mr-2 w-8 h-8 text-tertiary animate-spin fill-primary"
        viewBox="0 0 100 101"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
          fill="currentColor"
        ></path>
        <path
          d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
          fill="currentFill"
        ></path>
      </svg>
    </div>
    <span className="pl-4">Loading...</span>
  </div>;
}
